import React from 'react';
import ActionItemRow from './actionItemRow';

class ActionItemWidget extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      rows: this.props.rows || [],
      checkbox: this.props.checkbox || 0,
      events: this.props.events || {},
      readItemsFromProps: 0,
    };
  }

  render () {
    const { checkbox, events, rows: stateRows = [] } = this.state;
    const { readItemsFromProps, selectedItems = [], rows: propRows = [] } = this.props;

    const rows = readItemsFromProps == '1' ? propRows : stateRows;
    return (
      <div className="aiwidget-table" style={{ margin: '0px' }}>
        {
          rows.map(row =>
            <ActionItemRow
              ai={row}
              checkbox={checkbox}
              events={events}
              key={`ai_widget_row_comp_${row.id}`}
              selectedItems={selectedItems}
            />)
        }
      </div>
    );
  }
}

export default ActionItemWidget;
